import { colorPresets } from '@meitu/saas-editor-core/es/layers/chart-layer/presets';
import { nextColorGetter } from '@meitu/saas-editor-core/es/layers/chart-layer/utils/chart-color';
import IconFont from '@meitu/xdesign-icon-font';
import { ColorGroup } from '@meitu/xdesign-widgets';
import { ActionInfo } from '../../types';
import ChartCommonSelect from '../chart-common-select';
import './index.less';

const PresetColorsSelector: React.FC<{
    currentColors: string[];
    onChangeColors: (colors: string[]) => void;
    onAction?: (actionInfo: ActionInfo) => void;
    onOpenChange?: (open: boolean) => void;
}> = ({ currentColors, onChangeColors, onAction, onOpenChange }) => {
    const getLabel = (colors: string[], isInDropDownList = false) => (
        <ul className="colors-box">
            {colors.slice(0, 6).map((color, i) => (
                <li key={i}>
                    {isInDropDownList ? (
                        <div className="color-box" style={{ background: color, borderRadius: 4 }} />
                    ) : (
                        <ColorGroup
                            onOpenChange={onOpenChange}
                            popupTriggerSize={{
                                width: 20,
                                height: 20,
                            }}
                            color={color}
                            setColor={(val) => {
                                const newColors = [...currentColors];
                                newColors[i] = val;
                                onChangeColors(newColors);
                            }}
                            setColorAfter={() => {
                                onAction?.({ target: 'chartSerieColorChange', data: { isFromEditModal: false } });
                            }}
                            showIcon={false}
                            isGradient={false}
                            onToggleBizTab={(bizTab) => {
                                if (bizTab === 'team') {
                                    console.log('TODO');
                                }
                            }}
                        >
                            {({ PopupTrigger }) => (
                                <div className="color-box" style={{ background: color }}>
                                    {PopupTrigger}
                                </div>
                            )}
                        </ColorGroup>
                    )}
                </li>
            ))}
        </ul>
    );
    return (
        <ChartCommonSelect
            className="preset-colors-selector"
            popupClassName="preset-colors-selector__dropdown"
            value={{ label: getLabel(currentColors, false), value: JSON.stringify(currentColors) }}
            options={colorPresets.map((preset) => ({
                value: JSON.stringify(preset.colors),
                label: getLabel(preset.colors, true),
            }))}
            labelInValue
            suffixIcon={<IconFont name="ChevronDownBlack" fontSize={10} color="var(--content-input-label)" />}
            onChange={({ value }) => {
                const newColors = JSON.parse(value).slice(0, currentColors.length) as string[];
                onChangeColors(newColors);
                onAction?.({ target: 'chartColorsPreset', data: 'isUse' });
                nextColorGetter.resetSource(newColors[newColors.length - 1]);
            }}
            onDropdownVisibleChange={(visible) => {
                onOpenChange?.(visible);
                if (visible) {
                    onAction?.({ target: 'chartColorsPreset', data: 'isClick' });
                }
            }}
        />
    );
};

PresetColorsSelector.displayName = 'PresetColorsSelector';

export default PresetColorsSelector;
